/* EVENTS */
export const WISHLIST_ADD_EVENT = 'add_favorite'
export const WISHLIST_ADD_TO_LIST_EVENT = 'add_favorite_to_list'
